import { render } from "./CustomizationGroupSelector.vue?vue&type=template&id=898a7568&scoped=true"
import script from "./CustomizationGroupSelector.vue?vue&type=script&lang=js"
export * from "./CustomizationGroupSelector.vue?vue&type=script&lang=js"

import "./CustomizationGroupSelector.vue?vue&type=style&index=0&id=898a7568&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-898a7568"]])

export default __exports__